/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getAppointments } from 'app/entities/appointments/appointments.reducer';
import { getEntities as getPaymentSchemes } from 'app/entities/payment-scheme/payment-scheme.reducer';
import { getEntities as getGlucoUsers } from 'app/entities/gluco-user/gluco-user.reducer';
import { getEntities as getDoctors } from 'app/entities/doctor/doctor.reducer';
import { OrderStatus } from 'app/shared/model/enumerations/order-status.model';
import { ProcedureStatus } from 'app/shared/model/enumerations/procedure-status.model';
import { createEntity, getEntity, reset, updateEntity } from './op-procedure-order.reducer';

export const OpProcedureOrderUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const appointments = useAppSelector(state => state.appointments.entities);
  const paymentSchemes = useAppSelector(state => state.paymentScheme.entities);
  const glucoUsers = useAppSelector(state => state.glucoUser.entities);
  const doctors = useAppSelector(state => state.doctor.entities);
  const opProcedureOrderEntity = useAppSelector(state => state.opProcedureOrder.entity);
  const loading = useAppSelector(state => state.opProcedureOrder.loading);
  const updating = useAppSelector(state => state.opProcedureOrder.updating);
  const updateSuccess = useAppSelector(state => state.opProcedureOrder.updateSuccess);
  const orderStatusValues = Object.keys(OrderStatus);
  const procedureStatusValues = Object.keys(ProcedureStatus);

  const handleClose = () => {
    navigate(`/op-procedure-order${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getAppointments({}));
    dispatch(getPaymentSchemes({}));
    dispatch(getGlucoUsers({}));
    dispatch(getDoctors({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.totalCost !== undefined && typeof values.totalCost !== 'number') {
      values.totalCost = Number(values.totalCost);
    }

    const entity = {
      ...opProcedureOrderEntity,
      ...values,
      appointment: appointments.find(it => it.id.toString() === values.appointment?.toString()),
      scheme: paymentSchemes.find(it => it.id.toString() === values.scheme?.toString()),
      patient: glucoUsers.find(it => it.id.toString() === values.patient?.toString()),
      issuedBy: doctors.find(it => it.id.toString() === values.issuedBy?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          orderStatus: 'CREATED',
          procedureStatus: 'PLANNED',
          ...opProcedureOrderEntity,
          appointment: opProcedureOrderEntity?.appointment?.id,
          scheme: opProcedureOrderEntity?.scheme?.id,
          patient: opProcedureOrderEntity?.patient?.id,
          issuedBy: opProcedureOrderEntity?.issuedBy?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.opProcedureOrder.home.createOrEditLabel" data-cy="OpProcedureOrderCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.opProcedureOrder.home.createOrEditLabel">Create or edit a OpProcedureOrder</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="op-procedure-order-id"
                  label={translate('tinyMedicRestApp.opProcedureOrder.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.opProcedureOrder.active')}
                id="op-procedure-order-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.opProcedureOrder.microSec')}
                id="op-procedure-order-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.opProcedureOrder.timestampEntry')}
                id="op-procedure-order-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.opProcedureOrder.lastUpdated')}
                id="op-procedure-order-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.opProcedureOrder.cursor')}
                id="op-procedure-order-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.opProcedureOrder.totalCost')}
                id="op-procedure-order-totalCost"
                name="totalCost"
                data-cy="totalCost"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.opProcedureOrder.notes')}
                id="op-procedure-order-notes"
                name="notes"
                data-cy="notes"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.opProcedureOrder.orderStatus')}
                id="op-procedure-order-orderStatus"
                name="orderStatus"
                data-cy="orderStatus"
                type="select"
              >
                {orderStatusValues.map(orderStatus => (
                  <option value={orderStatus} key={orderStatus}>
                    {translate(`tinyMedicRestApp.OrderStatus.${orderStatus}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.opProcedureOrder.billed')}
                id="op-procedure-order-billed"
                name="billed"
                data-cy="billed"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.opProcedureOrder.procedureStatus')}
                id="op-procedure-order-procedureStatus"
                name="procedureStatus"
                data-cy="procedureStatus"
                type="select"
              >
                {procedureStatusValues.map(procedureStatus => (
                  <option value={procedureStatus} key={procedureStatus}>
                    {translate(`tinyMedicRestApp.ProcedureStatus.${procedureStatus}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                id="op-procedure-order-appointment"
                name="appointment"
                data-cy="appointment"
                label={translate('tinyMedicRestApp.opProcedureOrder.appointment')}
                type="select"
              >
                <option value="" key="0" />
                {appointments
                  ? appointments.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="op-procedure-order-scheme"
                name="scheme"
                data-cy="scheme"
                label={translate('tinyMedicRestApp.opProcedureOrder.scheme')}
                type="select"
              >
                <option value="" key="0" />
                {paymentSchemes
                  ? paymentSchemes.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="op-procedure-order-patient"
                name="patient"
                data-cy="patient"
                label={translate('tinyMedicRestApp.opProcedureOrder.patient')}
                type="select"
                required
              >
                <option value="" key="0" />
                {glucoUsers
                  ? glucoUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="op-procedure-order-issuedBy"
                name="issuedBy"
                data-cy="issuedBy"
                label={translate('tinyMedicRestApp.opProcedureOrder.issuedBy')}
                type="select"
                required
              >
                <option value="" key="0" />
                {doctors
                  ? doctors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/op-procedure-order" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default OpProcedureOrderUpdate;
